import React from "react";
import { useTranslation } from "react-i18next";
import AnimateOnScroll from "./AnimateOnScroll";

export default function Testimonial() {
    const { t } = useTranslation();

    const items = [
        t("Scale.item1"),
        t("Scale.item2"),
        t("Scale.item3"),
        t("Scale.item4"),
        t("Scale.item5"),
        t("Scale.item6"),
    ];

    return (
        <section
            className="py-20"
            id="scale"
            style={{ background: 'linear-gradient(135deg, #010C66 0%, #1a237e 100%)' }}
        >
            <div className="container">
                <AnimateOnScroll animation="fadeUp">
                    <div className="text-center mb-12">
                        <p
                            className="text-xs font-semibold uppercase tracking-widest mb-3"
                            style={{ color: '#709CFF' }}
                        >
                            {t("Scale.label")}
                        </p>
                        <h2
                            className="text-white font-bold max-w-2xl mx-auto"
                            style={{
                                fontFamily: '"Wix Madefor Display", sans-serif',
                                fontSize: '2rem',
                            }}
                        >
                            {t("Scale.title")}
                        </h2>
                    </div>
                </AnimateOnScroll>

                <AnimateOnScroll animation="fadeUp" delay={80}>
                    <p
                        className="text-center text-xs font-semibold uppercase tracking-widest mb-6"
                        style={{ color: 'rgba(255,255,255,0.5)' }}
                    >
                        {t("Scale.intro")}
                    </p>
                </AnimateOnScroll>

                <div className="grid grid-cols-2 lg:grid-cols-3 gap-4 max-w-3xl mx-auto mb-12">
                    {items.map((item, i) => (
                        <AnimateOnScroll key={i} animation="fadeUp" delay={i * 60}>
                            <div
                                className="rounded-xl p-4 text-center h-full flex items-center justify-center"
                                style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)' }}
                            >
                                <p style={{ color: 'rgba(255,255,255,0.85)', fontSize: '0.85rem', fontWeight: 500 }}>{item}</p>
                            </div>
                        </AnimateOnScroll>
                    ))}
                </div>

                <AnimateOnScroll animation="fadeUp" delay={150}>
                    <p
                        className="text-center max-w-2xl mx-auto"
                        style={{ color: 'rgba(255,255,255,0.6)', lineHeight: 1.7, fontSize: '0.9rem' }}
                    >
                        {t("Scale.experience")}
                    </p>
                </AnimateOnScroll>
            </div>
        </section>
    );
}
